<template>
  <div class="form-select" :class="{ disabled: disabled }" @click.stop="">
    <div class="select-input" @click="showList">
      <input
        type="text"
        :placeholder="selectName"
        v-model="searchWord"
        @keydown="keydownHandler"
        @keyup="keyupHandler"
        @blur="hideList"
        :disabled="disabled"
      />
      <e-icon icon="yicon-up2" v-if="ifShow" @click.native.stop="hideList"></e-icon>
      <e-icon icon="yicon-down2" v-if="!ifShow" @click="showList"></e-icon>
    </div>
    <transition name="list">
      <dl class="select-list" v-show="ifShow && ifMatch && !disabled">
        <dd
          v-for="(item, index) in filterList"
          :value="item[val]"
          @mousedown="setSelectData($event, item.listIndex)"
          @mouseover="changeActive(item.listIndex)"
          :key="index"
          :class="{
            'is-selected': item.realIndex === selectIndex,
            'is-active': item.listIndex === activeIndex,
          }"
          :style="{ height: ddHeight + 'px' }"
        >
          {{ item[label] }}
        </dd>
      </dl>
    </transition>
    <transition>
      <dl class="select-list" v-if="this.filterList.length === 0 && !disabled">
        <dd>Not found</dd>
      </dl>
    </transition>
  </div>
</template>

<script scroped>
import EIcon from '../components/Icon.vue'

export default {
  data() {
    return {
      ifShow: false,
      ifMatch: true,
      selectVal: this.defaultVal,
      activeIndex: 0,
      selectIndex: 0,
      searchWord: '',
      ddHeight: 30,

      keyCode: {
        enter: 13,
        up: 38,
        down: 40,
      },
    }
  },
  computed: {
    selectName() {
      return this.placeholder
        ? this.placeholder
        : this.showLabel(this.selectVal, this.selectlist, this.val, true, this.label)
    },
    filterList() {
      /* eslint-disable */
      let ifInfilterList = false
      let firstIndex = 0
      let ifFirst = false
      let j = 0
      let filteredList = []

      let filterItem = (ifFind, item) => {
        if (ifFind) {
          item.listIndex = j++
          if (!ifFirst) {
            ifFirst = true
            firstIndex = item.listIndex
          }
          if (item.isActive) {
            ifInfilterList = true
            this.activeIndex = item.listIndex
          }
        }

        return ifFind
      }

      if (this.advancedSearch) {
        let advancedList = this.selectlist.filter(item => {
          let ifFind =
            item[this.advancedSearch].toLowerCase().indexOf(this.searchWord.toLowerCase()) !== -1
          return filterItem(ifFind, item)
        })

        let secondlyList = this.selectlist.filter(item => {
          let ifFind =
            item[this.advancedSearch].toLowerCase().indexOf(this.searchWord.toLowerCase()) === -1 &&
            item[this.label].toLowerCase().indexOf(this.searchWord.toLowerCase()) !== -1
          return filterItem(ifFind, item)
        })

        filteredList = [...advancedList, ...secondlyList]
      } else {
        let arr = this.selectlist.filter(item => {
          let ifFind = item[this.label].toLowerCase().indexOf(this.searchWord.toLowerCase()) !== -1
          return filterItem(ifFind, item)
        })

        filteredList = [...arr]
      }

      if (!ifInfilterList) {
        this.activeIndex = firstIndex
        this.selectlist.map(item => {
          item.isActive = false
        })
        this.selectlist[0].isActive = true
        try {
          let el = this.$el.getElementsByClassName('select-list')[0]
          el.scrollTop = 0
        } catch (e) {}
      }

      return filteredList
      /* eslint-enable */
    },
  },
  created() {
    this.init()
  },
  props: {
    disabled: {
      type: Boolean,
      default() {
        return false
      },
    },
    selectlist: {
      type: Array,
      default() {
        return []
      },
    },
    defaultVal: {
      type: String,
      default() {
        return ''
      },
    },
    val: String,
    label: String,
    placeholder: String,
    advancedSearch: {
      type: String,
      default() {
        return ''
      },
    },
  },
  methods: {
    init() {
      for (let i = 0, il = this.selectlist.length; i < il; i++) {
        let item = this.selectlist[i]
        this.selectlist[i].realIndex = i

        if (this.defaultVal === item[this.val]) {
          this.activeIndex = i
          this.selectIndex = i
          item.isActive = true
        }
      }
    },
    showLabel(label, list, key, is_all, value) {
      var result = ''
      if (!list || !list.length || (!label && !is_all)) {
        return result
      }
      for (var i = 0, il = list.length; i < il; i++) {
        var item = list[i]
        if (label === item[key || 'id']) {
          result = item[value || 'name']
          break
        }
      }
      return result
    },
    setSelectData(event, index) {
      this.selectVal = event.currentTarget.getAttribute('value')
      this.activeIndex = this.filterList[index].realIndex
      this.selectIndex = this.filterList[index].realIndex
      this.$emit('selectDataChange', this.selectVal)
      this.searchWord = ''
    },
    hideList() {
      this.ifShow = false
      this.searchWord = ''
    },
    showList(e) {
      if (this.disabled) {
        return
      }
      this.ifShow = true
      let selectList = e.target.parentNode.parentNode.getElementsByClassName('select-list')[0]
      if (this.selectIndex) {
        this.activeIndex = this.selectIndex
        setTimeout(() => {
          let top = this.activeIndex * this.ddHeight
          selectList.scrollTop = top
        }, 0)
      }
    },
    keydownHandler(e) {
      if (!this.ifShow) {
        this.showList(e)
      } else {
        if (e.keyCode === this.keyCode.enter) {
          let index = this.activeIndex
          this.selectIndex = this.filterList[this.activeIndex].realIndex
          this.selectVal = this.filterList[index][this.val]
          this.$emit('selectDataChange', this.selectVal)
          this.searchWord = ''
          this.hideList()
        } else if (e.keyCode === this.keyCode.down) {
          this.move(e, 'down')
        } else if (e.keyCode === this.keyCode.up) {
          this.move(e, 'up')
        }
      }
    },
    keyupHandler(e) {
      if (
        e.keyCode !== this.keyCode.enter &&
        e.keyCode !== this.keyCode.down &&
        e.keyCode !== this.keyCode.up
      ) {
        if (!this.ifShow) {
          this.showList(e)
        }
      }
    },
    move(e, direction) {
      let scroll = e.target.parentNode.parentNode.getElementsByClassName('select-list')[0]
      if (this.ifMatch) {
        if (direction === 'down' && this.activeIndex < this.filterList.length - 1) {
          scroll.scrollTop += this.ddHeight
          this.activeIndex++
        } else if (direction === 'up' && this.activeIndex >= 1) {
          scroll.scrollTop -= this.ddHeight
          this.activeIndex--
        }
      }
    },
    changeActive(index) {
      this.activeIndex = index
    },
  },
  watch: {
    selectlist() {
      this.init()
      this.selectVal = this.defaultVal
    },
  },
  components: {
    EIcon,
  },
}
</script>

<style scoped>

.form-select {
  width: 100%;
  position: relative;
  text-align: left;
  display: inline-block;
}

.form-select .icon {
  position: absolute;
  top: 25%;
  right: 20px;
  color: #606266;
  cursor: pointer;
}

.form-select input::-webkit-input-placeholder {
  font-size: 16px;
}

.form-select dl {
  width: 100%;
  text-align: left;
  margin: 4px 0 0 0;
  padding: 0;
  background-color: white;
}
.form-select dd {
  width: 100%;
  margin: 0;
  padding: 0 20px;
  font-size: 14px;
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #606266;
  line-height: 30px;
  box-sizing: border-box;
  cursor: pointer;
}

.form-select dd.is-selected {
  background: #eef0f6;
}
.form-select dd.is-active {
  background: #f6f6f6;
}
.form-select .is-selected {
  color: #676565;
  font-weight: 600;
}
.select-input {
  white-space: nowrap;
}
input {
  height: 38px;
  padding-right: 20px;
  padding-left: 18px;
  border: 1px solid #e1e4eb;
  border-radius: 8px;
  width: 100%;
  position: relative;
  background: #fff;
  outline: 0;
  box-sizing: border-box;
}

.disabled input {
  background: #eef0f6;
  color: #c7cbd2;
}

input:focus {
  outline: 0;
  border-color: rgba(111, 146, 235, 0.6) !important;
}
.select-list {
  position: absolute;
  width: 100%;
  max-height: 280px;
  overflow-y: auto;
  z-index: 999;

  background-color: #fff;
  border-radius: 5px;
  -webkit-box-shadow: 0 0 0 1px rgba(68, 68, 68, 0.11);
  box-shadow: 0 0 0 1px rgba(68, 68, 68, 0.11);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0;
  -webkit-transform-origin: 50% 0;
  transform-origin: 50% 0;
  -webkit-transform: scale(0.75) translateY(-21px);
  transform: scale(0.75) translateY(-21px);
  -webkit-transition: all 0.2s cubic-bezier(0.5, 0, 0, 1.25), opacity 0.15s ease-out;
  transition: all 0.2s cubic-bezier(0.5, 0, 0, 1.25), opacity 0.15s ease-out;
  -webkit-transform: scale(1) translateY(0);
  transform: scale(1) translateY(0);
}

.list-item {
  display: inline-block;
  margin-right: 10px;
}
.list-enter-active,
.list-leave-active {
  transition: all 0.3s;
}
.list-enter,
.list-leave-to {
  opacity: 0;
}

.disabled input:hover {
  cursor: not-allowed;
}
</style>
